module.exports = __webpack_public_path__ + "static/media/cMinistrySmall.95b15f3d.png";